import React from "react";
import { ExpandableConfigurationSection } from "components/Launchables/DeployRedesign/shared/configuration/ExpandableConfigurationSection";
import { NgcApiKeyOption } from "./NgcApiKeyOption";

interface NgcApiKeyConfigurationProps {
  visible: boolean;
  open: boolean;
  onToggle: () => void;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  errorMessage?: string | null;
  disabled: boolean;
  isAiPlaygroundsKey: boolean;
}

export const NgcApiKeyConfiguration: React.FC<NgcApiKeyConfigurationProps> = ({
  visible,
  open,
  onToggle,
  checked,
  onCheckedChange,
  errorMessage,
  disabled,
  isAiPlaygroundsKey,
}) => {
  if (!visible) return null;

  return (
    <ExpandableConfigurationSection
      id="launchable-api-key"
      title="NVIDIA API key"
      summary={
        isAiPlaygroundsKey
          ? "Access hosted NVIDIA models"
          : "Create a key for this launchable"
      }
      status={
        errorMessage ? "Needs attention" : checked ? "Selected" : "Not selected"
      }
      statusTone={errorMessage ? "attention" : checked ? "positive" : "neutral"}
      open={open}
      onToggle={onToggle}
    >
      <div className="px-5 py-4">
        <NgcApiKeyOption
          checked={checked}
          onCheckedChange={onCheckedChange}
          errorMessage={errorMessage}
          disabled={disabled}
          isAiPlaygroundsKey={isAiPlaygroundsKey}
        />
      </div>
    </ExpandableConfigurationSection>
  );
};
